<template>
    <vx-card class="graphStatType">
        <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="7" vs-lg="5">
                <table>
                    <tr :style="{'color':themeColors[4] }">
                        <td>Prospect</td>
                        <td>{{ prospect }}</td>
                    </tr>
                    <tr :style="{'color':themeColors[0] }">
                        <td>Essai</td>
                        <td>{{ essai }}</td>
                    </tr>
                    <tr :style="{'color':themeColors[1] }">
                        <td>Actif</td>
                        <td>{{ actif }}</td>
                    </tr>
                    <tr :style="{'color':themeColors[2] }">
                        <td>Inactif</td>
                        <td>{{ inactif }}</td>
                    </tr>
                    <tr :style="{'color':themeColors[3] }">
                        <td>Suspendu</td>
                        <td>{{ suspendu }}</td>
                    </tr>
                </table>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="5" vs-lg="7">
                <vue-apex-charts ref="donut" type="donut" height="150" :options="donutChart.chartOptions" :series="donutChart.series"></vue-apex-charts>
            </vs-col>
        </vs-row>
    </vx-card>
</template>

<style lang="scss" scoped>
.graphStatType
{
    @media only screen and (max-width: 300px)
    {
        .vx-card__body{
            padding:0px !important;
        }
    }
}
</style>

<script>
import VueApexCharts from 'vue-apexcharts'
import Member from '@/database/models/member'

export default {
    components:{
        VueApexCharts
	},
    props: {

    },
    data(){
        return{
            prospect: 0,
            actif   : 0,
            inactif : 0,
            essai   : 0,
            suspendu: 0,

            themeColors: [ Member.color.essai, Member.color.actif, Member.color.inactif, Member.color.suspendu, Member.color.prospect ],
            donutChart:
            {
                series: [0, 0, 0, 0, 0],
                chartOptions:
                {
                    labels: ["Essai", "Actif", "Inactif", "Suspendu", "Prospect" ],
                    colors: [ Member.color.essai, Member.color.actif, Member.color.inactif, Member.color.suspendu, Member.color.prospect ],
                    responsive: [
                    {
                        breakpoint: 480,
                        options:
                        {
                            legend:
                            {
                                show: false,
                                position: 'bottom'
                            },
                        }
                    }],
                    legend:{
                        show: false,
                    },
                },
            }
        }
    },
    mounted:function()
	{
        this.refresh()
    },
    methods:{
        refresh()
        {
            Member.getTabAllMemory((list)=>
            {
                //Build data
                for( var i=0; i< list.length; i++)
                {
                    var buffer = list[i];

					switch( Member.getTypeSpec( buffer ))
					{
						case 'essai':
							this.essai++;
						break;
						case 'actif':
							this.actif++;
						break;
						case'suspendu':
							this.suspendu++;
						break;
						case 'inactif':
							this.inactif++;
						break;
						case 'prospect':
							this.prospect++;
						break;
					}
                }

                //Update graph
                this.donutChart.series[0] = this.essai;
                this.donutChart.series[1] = this.actif;
                this.donutChart.series[2] = this.inactif;
                this.donutChart.series[3] = this.suspendu;
                this.donutChart.series[4] = this.prospect;

                //refresh graph
                this.$refs.donut.refresh();

            });
        }
    }
}

</script>